export default (scheme) => {
  if (scheme === 'MASTERCARD') return 'Mastercard';
  if (scheme === 'VISA') return 'Visa';
  if (scheme === 'AMEX') return 'American Express';

  return scheme;
};
